module.exports = __webpack_public_path__ + "static/media/promotions.7ae59b38.webp";